import { render, staticRenderFns } from "./list.vue?vue&type=template&id=01b945fb&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b945fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b945fb')) {
      api.createRecord('01b945fb', component.options)
    } else {
      api.reload('01b945fb', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=01b945fb&scoped=true", function () {
      api.rerender('01b945fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/remitAccount/list.vue"
export default component.exports